import React from 'react';
import { Form } from '@/components/ui/form';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { cn } from '@gettactic/helpers';

export interface ReserveFormFormProps {
  className?: string;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
}

export const ReserveFormForm: React.FC<
  React.PropsWithChildren<ReserveFormFormProps>
> = ({ children, className, onSubmit }) => {
  const { form } = useReserveForm();
  return (
    <Form {...form}>
      <form
        className={cn('v2-reservation flex flex-col text-left', className)}
        onSubmit={onSubmit}
      >
        {children}
      </form>
    </Form>
  );
};
